import type {DeepPartial} from 'react-hook-form';

import type {FinancingEndingEmailSourceRequestBody} from '@dms/api/sales';
import {normalizeEmailHtml} from '@dms/shared';

import {
  FinancingEndingEditableEmailFormSchema,
  type FinancingEndingEditableEmailFormValues,
} from './FinancingEndingEditableEmailFormSchema';

export type FinancingEndingEmailDraft = Readonly<{
  emailCredentialsId: string;
  source: Readonly<FinancingEndingEmailSourceRequestBody>;
}>;

/**
 * The text the preview renders and the submit stores, taken from the compose form values the way the
 * form submits them: the subject trimmed and the body normalized once, `{{ code }}` placeholders
 * kept. `null` while a required value is missing, so nothing is previewed or sent for it.
 */
export const getFinancingEndingEmailDraft = (
  values: DeepPartial<FinancingEndingEditableEmailFormValues>
): FinancingEndingEmailDraft | null => {
  const result = FinancingEndingEditableEmailFormSchema.safeParse(values);

  if (!result.success) {
    return null;
  }

  const {emailCredentialsId, subject, body, templateId, locale} = result.data;

  return Object.freeze({
    emailCredentialsId,
    source: Object.freeze({subject, body: normalizeEmailHtml(body), templateId, locale}),
  });
};
